export enum TransactionStatus {
  Failed,
  Successful,
}

export enum TransactionType {
  Withdraw,
  Deposit,
}

export class Transactions {
  amount: number;
  currency: string;
  firstName: string;
  lastName: string;
  paymentId: string;
  phoneNumber: number;
  tokenId: string;
  transactionTime: Date;
  transactionType: TransactionType;
  userId: string;
  transactionStatus: TransactionStatus;

  constructor(
    amount?: number,
    currency?: string,
    firstName?: string,
    lastName?: string,
    paymentId?: string,
    phoneNumber?: number,
    tokenId?: string,
    transactionTime?: Date,
    transactionType?: TransactionType,
    userId?: string,
    transactionStatus?: TransactionStatus
  ) {
    this.amount = amount;
    this.currency = currency;
    this.firstName = firstName;
    this.lastName = lastName;
    this.paymentId = paymentId;
    this.phoneNumber = phoneNumber;
    this.tokenId = tokenId;
    this.transactionTime = transactionTime || new Date();
    this.transactionType = transactionType;
    this.userId = userId;
    this.transactionStatus = transactionStatus;
  }
}
